import React, { useEffect, useRef, useState } from "react";
import check from "../../../../assets/images/svgs/check.svg";
import checkGray from "../../../../assets/images/svgs/checkGray.svg";
import checkRed from "../../../../assets/images/svgs/checkRed.svg";
import "./style.scss";
import { Drawer } from "antd";
import { formatQuesNumber } from "../../../../functions/common";
import { useNavigate } from "react-router-dom";
import RoundedBtn from "../../../../components/buttons/roundedBtn";

const QuestionArrSidebar = ({
  questionArr,
  selectQuestion,
  selectedQues,
  openDrawer = true,
  setOpenDrawer,
  answersDone,
  parsedQuestions,
  checkUnAnswered,
  showSubmit,
  setShowInstructions,
  showInstructions,
  isSubmitted,
  alertRequired
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const questionRefs = useRef({}); // Store references to question buttons
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Scroll to selected question
    if (selectedQues && questionRefs.current[selectedQues]) {
      questionRefs.current[selectedQues].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [selectedQues]);

  const handleSelect = (refCode) => {
    const index = parsedQuestions.findIndex((v) => v?.refCode === refCode);
    selectQuestion(index);
  };

  const gotoLocation = () => navigate("/location");

  const openInstructions = () => {
    setShowInstructions(true);
    setOpenDrawer(false);
  };

  return (
    <>
      {windowWidth > 768 ? (
        <div className="sidebar__section">
          <div className="sidebar__sub__section">
            {questionArr?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((item, index) => (
              <div className="question__sidebar__item" key={index}>
                {index === 0 ? (
                  <button
                    disabled={isSubmitted}
                    onClick={openInstructions}
                    className={showInstructions ? "is__selected mt-2" : "mt-2"}
                  >
                    <p>
                      <h3>Instructions</h3>
                    </p>
                  </button>
                ) : (
                  ""
                )}
                <h3>{item?.title}</h3>
                {item?.questionnaire?.map((v, i) => {
                  const isCompleted = answersDone?.[v?.refCode];
                  return (
                    <button
                      key={v?.refCode}
                      ref={(el) => (questionRefs.current[v?.refCode] = el)}
                      className={
                        selectedQues === v?.refCode &&
                        !showSubmit &&
                        !showInstructions
                          ? "is__selected"
                          : ""
                      }
                      disabled={isSubmitted}
                      onClick={() => handleSelect(v?.refCode)}
                    >
                      <div className="check__section">
                        <img
                          alt=""
                          src={
                            isCompleted
                              ? check
                              : v?.isRequired && alertRequired
                              ? checkRed
                              : checkGray
                          }
                        />
                      </div>
                      <p>
                        {formatQuesNumber(v?.category_sorted_refCode)}.{" "}
                        {v?.shortDescriptionOfQuestion}
                        {v?.isRequired ? "*" : ""}
                      </p>
                    </button>
                  );
                })}
                {/* eslint-disable-next-line eqeqeq */}
                {questionArr?.length - 1 == index && (
                  <button
                    onClick={checkUnAnswered}
                    className={showSubmit ? "is__selected" : ""}
                  >
                    <div className="check__section">
                      <img alt="" src={isSubmitted ? check : checkGray} />
                    </div>
                    <h3>Assessment Submission</h3>
                  </button>
                )}
              </div>
            ))}
          </div>
          <div className="vertical__line"></div>
        </div>
      ) : (
        <Drawer
          closable
          destroyOnClose
          placement="left"
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          classNames={{
            body: "p-0",
          }}
          title={
            <div className="px-2">
              <RoundedBtn onClick={gotoLocation} text={"Main Page"} />
            </div>
          }
        >
          <div className="sidebar__section">
            <div className="sidebar__sub__section">
              {questionArr?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((item, index) => (
                <div className="question__sidebar__item" key={index}>
                  {index === 0 ? (
                    <button
                      disabled={isSubmitted}
                      onClick={openInstructions}
                      className={
                        showInstructions ? "is__selected mt-2" : "mt-2"
                      }
                    >
                      <p>
                        <h3>Instructions</h3>
                      </p>
                    </button>
                  ) : (
                    ""
                  )}
                  <h3>{item?.title}</h3>
                  {item?.questionnaire?.map((v, i) => {
                    const isCompleted = answersDone?.[v?.refCode];
                    return (
                      <button
                        key={v?.refCode}
                        ref={(el) => (questionRefs.current[v?.refCode] = el)}
                        className={
                          selectedQues === v?.refCode &&
                          !showSubmit &&
                          !showInstructions
                            ? "is__selected"
                            : ""
                        }
                        disabled={isSubmitted}
                        onClick={() => handleSelect(v?.refCode)}
                      >
                        <div className="check__section">
                          {isCompleted || v?.isRequired ? (
                            <img
                              alt=""
                              src={
                                isCompleted
                                  ? check
                                  : v?.isRequired && alertRequired
                                  ? checkRed
                                  : checkGray
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                        <p>
                          {formatQuesNumber(v?.category_sorted_refCode)}.{" "}
                          {v?.shortDescriptionOfQuestion}
                        </p>
                      </button>
                    );
                  })}
                  {/* eslint-disable-next-line eqeqeq */}
                  {questionArr?.length - 1 == index && (
                    <button
                      onClick={checkUnAnswered}
                      className={showSubmit ? "is__selected" : ""}
                    >
                      <div className="check__section">
                        <img alt="" src={isSubmitted ? check : checkGray} />
                      </div>
                      <h3>Assessment Submission</h3>
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </Drawer>
      )}
    </>
  );
};

export default QuestionArrSidebar;
